import type { TranscriptionLanguagePage } from '@/constants/transcriptionLanguagePages';

import samples from './languageSamples.json';
import type { TranscriptExample } from './TranscriptMock';

type LanguageSample = {
  lang: string;
  file: string;
  speakers: string[];
  lines: string[];
  summary: string[];
};

const SAMPLES = samples as Record<string, LanguageSample>;

// Who says each line of the sample meeting, and when.
const TURNS = [
  { speaker: 0, time: '0:04' },
  { speaker: 1, time: '0:11' },
  { speaker: 0, time: '0:19' },
  { speaker: 2, time: '0:26' },
];

/**
 * The language page's example: the same short team meeting, spoken (and
 * shown) in that language whatever language the page itself is in.
 */
export function languageExample(
  language: TranscriptionLanguagePage,
): TranscriptExample {
  const sample = SAMPLES[language.slug] ?? SAMPLES.english;
  return {
    file: sample.file,
    source: 'file',
    language: language.name,
    duration: '32:18',
    speakers: sample.speakers,
    lines: TURNS.map((turn, index) => ({
      ...turn,
      text: sample.lines[index] ?? '',
    })),
    playing: 1,
    insight: {
      title: 'Summary',
      kind: 'bullets',
      items: sample.summary.map((text) => ({ text })),
    },
    textLang: sample.lang,
  };
}
